var modal_for_deviceIds = document.getElementById("Modal_for_deviceIds");
var span = document.getElementsByClassName("close_for_deviceIds")[0];

function sanitizeSerialPopupPlain(value, maxLen) {
    var s = DOMPurify.sanitize(String(value), { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
    if (maxLen) {
        s = s.slice(0, maxLen);
    }
    return s;
}

/** After DOMPurify, XSS probes often still contain letters (e.g. x, alert). Drop those; keep normal IDs. */
function shouldRenderSerialIdRow(plainId) {
    var t = String(plainId).trim();
    if (!t) {
        return false;
    }
    if (!/[A-Za-z0-9]/.test(t)) {
        return false;
    }
    // Entity junk (e.g. literal &gt; after sanitize) — real IDs do not use HTML entities
    if (t.indexOf('&') !== -1) {
        return false;
    }
    // Legit IDs here use " | " (from "/"), not angle brackets; leftover XSS text often has < or >
    if (/[<>]/.test(t)) {
        return false;
    }
    var lower = t.toLowerCase();
    if (lower.indexOf('onerror') !== -1 || lower.indexOf('onload') !== -1) {
        return false;
    }
    if (lower.indexOf('onclick') !== -1 || lower.indexOf('onfocus') !== -1) {
        return false;
    }
    if (/alert\s*\(/.test(lower)) {
        return false;
    }
    if (lower.indexOf('javascript:') !== -1) {
        return false;
    }
    if (/\beval\s*\(/.test(lower)) {
        return false;
    }
    if (lower.indexOf('<script') !== -1) {
        return false;
    }
    return true;
}

function appendSerialIdCheckboxRow(parentEl, plainId) {
    var row = document.createElement('div');
    row.className = 'serial-id-container';
    var cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.className = 'serialId_checkbox';
    cb.id = plainId;
    var lab = document.createElement('label');
    lab.htmlFor = plainId;
    lab.textContent = plainId;
    row.appendChild(cb);
    row.appendChild(lab);
    row.appendChild(document.createElement('br'));
    parentEl.appendChild(row);
}

async function storeDeviceGroups() { 
  
    var deviceGroups = document.getElementsByClassName("device-group");  
    var deviceGroupsData = [];  
  
    for (var i = 0; i < deviceGroups.length; i++) {  
        var deviceGroup = deviceGroups[i];  
        var checkboxes = deviceGroup.getElementsByClassName("serialId_checkbox");  
        var checkboxIds = [];  
  
        for (var j = 0; j < checkboxes.length; j++) {  
            checkboxIds.push(checkboxes[j].id);  
        }  
  
        deviceGroupsData.push({  
            id: deviceGroup.id,  
            checkboxIds: checkboxIds  
        });  
    }  
  
    sessionStorage.setItem('deviceGroups', JSON.stringify(deviceGroupsData));  
    // console.log("2");
}  

async function useDeviceGroupsData() { 
   
    var checkedItems = JSON.parse(sessionStorage.getItem('checkedItems')) || {};  
    var deviceGroupsData = JSON.parse(sessionStorage.getItem('deviceGroups'));  
  
    // console.log("deviceGroupsData", deviceGroupsData);  
    // console.log("Starting the code to retain checkbox");  
  
    for (var i = 0; i < deviceGroupsData.length; i++) {  
        // console.log("in the main loop");  
        var deviceGroupData = deviceGroupsData[i];  
        var deviceGroupId = deviceGroupData.id;  
        var checkboxIds = deviceGroupData.checkboxIds;  
  
        // console.log("deviceGroupId", deviceGroupId);  
        // console.log("checkboxIds", checkboxIds);  
  
        for (var j = 0; j < checkboxIds.length; j++) {  
            var checkboxId = checkboxIds[j];  
            var checkbox = document.getElementById(checkboxId);  
  
            // console.log("checkbox", checkbox);  
            // console.log("checkedItems[deviceGroupId]", checkedItems[deviceGroupId]);  
            // console.log("checkedItems[deviceGroupId].includes(checkbox.id)", checkedItems[deviceGroupId].includes(checkbox.id));  
  
            if (checkedItems[deviceGroupId] && checkedItems[deviceGroupId].includes(checkbox.id)) {  
                checkbox.checked = true;  
                // console.log("In checking code");  
            }  
        }  
    } 
  // console.log("3");
}  
  
function handleDeviceIdsChange() { 
    
    var errorElement = document.querySelector('.serialId-error');  
  
    var proceedButton = document.getElementById("modal_checkout");  
  
    var deviceGroups = document.querySelectorAll('.device-group');  
    var countD2 = 0;  
    var countD4 = 0;  
  
    deviceGroups.forEach(function(group) {  
        if (group.id.includes("D-2")) {  
            countD2 += group.querySelectorAll('.serialId_checkbox:checked').length;  
        } else if (group.id.includes("D-4")) {  
            countD4 += group.querySelectorAll('.serialId_checkbox:checked').length;  
        }  
    });  
    // console.log("in custom file countD2", countD2);
    // console.log("in custom file countD4", countD4);
    if (countD2 === window.sumD2incart && countD4 === window.sumD4incart) {  
        errorElement.style.display = 'none';  
        proceedButton.disabled = false;  
    } else {  
        errorElement.style.display = 'block';  
        proceedButton.disabled = true;  
    }   
} 

async function openModal_for_deviceIds(productNames) {  
    
    modal_for_deviceIds.style.display = "block";  
    document.getElementById("spinner-deviceIDpopup").style.display = "block";  
    document.getElementById("modal_checkout").style.color = "white";  
    document.getElementById("modal_checkout").disabled = true;  
    document.getElementById("modal_checkout").style.display = "none";  
  
    return fetch(window.api_url_device_count, {  
            method: "POST",
            headers: {  
                "Content-Type": "application/json",  
                Authorization: "Bearer " + window.AnaToken,  
            },  
            body: JSON.stringify({  
                SFID: window.SF_ID,  
                CUSTID: window.Cust_ID,  
            }),  
        })  
        .then((response) => {  
            if (!response.ok) {  
            }  
            return response.json();  
        })  
        .then((data) => {  
            // console.log("data from custom_popup", data);  
            if (data.status !== "200") {  
            }  
            // console.log("Success:", data);  
        })  
        .catch((error) => {  
            document.getElementById("spinner-deviceIDpopup").style.display = "none";  
            document.getElementById("modal_checkout").disabled = true;  
            document.getElementById("modal_checkout").style.display = "inline";  
        })  
        .finally(() => {  
            var customFields = window.customFields || {};

            var deviceIdsRoot = document.getElementById("device-ids");
            deviceIdsRoot.innerHTML = "";

            var hasContent = false;
            const uniqueProductCodes = new Set();

            productNames.forEach(function(productName) {
                const productCodeMatch = productName.match(/(D-\d+)/);
                if (productCodeMatch) {
                    uniqueProductCodes.add(productCodeMatch[0]);
                }
            });

            uniqueProductCodes.forEach(function(productCode) {
                for (var key in customFields) {
                    if (
                        (productCode.includes("D-2") && key.includes("D-2")) ||
                        (productCode.includes("D-4") && key.includes("D-4"))
                    ) {
                        var obj = JSON.parse(customFields[key]);
                        if (
                            Array.isArray(obj.OOW_DEVICE_IDS) &&
                            obj.OOW_DEVICE_IDS.length > 0
                        ) {
                            var safeKey = sanitizeSerialPopupPlain(key, 120);
                            var groupEl = document.createElement("div");
                            groupEl.className = "device-group";
                            groupEl.id = safeKey;

                            var titleEl = document.createElement("p");
                            titleEl.className = "device-modals";
                            titleEl.textContent = "Driver•i " + safeKey;
                            groupEl.appendChild(titleEl);

                            var addedRow = false;
                            obj.OOW_DEVICE_IDS.forEach(function(id) {
                                var formatted_id = String(id).replace("/", " | ");
                                var plainId = sanitizeSerialPopupPlain(formatted_id, 200);
                                if (!shouldRenderSerialIdRow(plainId)) {
                                    return;
                                }
                                appendSerialIdCheckboxRow(groupEl, plainId);
                                addedRow = true;
                            });

                            if (addedRow) {
                                deviceIdsRoot.appendChild(groupEl);
                                hasContent = true;
                            }
                        }
                    }
                }
            });

            if (!hasContent) {
            }
            document.getElementById("spinner-deviceIDpopup").style.display = "none";
            document.getElementById("modal_checkout").disabled = false;
            document.getElementById("modal_checkout").style.display = "inline";
        });  


    // console.log("1");  
}  

  


span.onclick = function() {
    modal_for_deviceIds.style.display = "none";
};

window.onclick = function(event) {
    if (event.target == modal_for_deviceIds) {
        modal_for_deviceIds.style.display = "none";
    }
};

function runCheckoutFlow(cart) {
    if (typeof window.ds2ValidateCartSubscribedBeforeCheckout === 'function') {
        if (!window.ds2ValidateCartSubscribedBeforeCheckout()) {
            return;
        }
    }
    updateCartBlank();
    handleDeviceIdsChange();
    var productNames = [];
    var exceededItems = [];
    var cartItems = [];

    for (let i = 0; i < cart.items.length; i++) {
        if (
            cart.items[i].product_type === "Devices" &&
            (cart.items[i].title.includes("D-2") ||
                cart.items[i].title.includes("D-4"))
        ) {
            productNames.push(cart.items[i].title);
            cartItems.push([cart.items[i].product_type, cart.items[i].quantity, cart.items[i].title]);
            if (
                cart.items[i].title.includes("D-2") &&
                cart.items[i].quantity > window.sumD2
            ) {
                exceededItems.push(cart.items[i].title);
            }
            if (
                cart.items[i].title.includes("D-4") &&
                cart.items[i].quantity > window.sumD4
            ) {
                exceededItems.push(cart.items[i].title);
            }
        }
    }

    sessionStorage.setItem('cartItems', JSON.stringify(cartItems));
    window.sumD2incart = 0;
    window.sumD4incart = 0;
    for (let i = 0; i < cartItems.length; i++) {
        if (cartItems[i][0] === "Devices") {
            if (cartItems[i][2].includes("D-2")) {
                window.sumD2incart += cartItems[i][1];
            } else if (cartItems[i][2].includes("D-4")) {
                window.sumD4incart += cartItems[i][1];
            }
        }
    }

    var totalSumInCart = window.sumD2incart + window.sumD4incart;
    var headingEl = document.querySelector('.checkout-popup-heading');
    var subheadingEl = document.querySelector('.checkout-popup-subheading ');
    if (headingEl) headingEl.innerHTML = `From the list below, select the ${totalSumInCart} devices you would like to replace.`;
    if (subheadingEl) subheadingEl.innerHTML = `If you wish to add more than ${totalSumInCart} device IDs, please return to the previous screen and update the quantity in your cart.`;

    var doNotProceedEl = document.getElementById('do-not-proceed');
    if (doNotProceedEl && exceededItems.length > 0) {
        doNotProceedEl.innerText = `${exceededItems.join(', ')} exceed your buy-out quantity.`;
    }

    if (productNames.length > 0) {
        var hasContent = productNames.some(function(productName) {
            return Object.keys(window.customFields || {}).some(function(key) {
                if (
                    (productName.includes("D-2") && key.includes("D-2")) ||
                    (productName.includes("D-4") && key.includes("D-4"))
                ) {
                    var obj = JSON.parse(window.customFields[key]);
                    return (
                        Array.isArray(obj.OOW_DEVICE_IDS) &&
                        obj.OOW_DEVICE_IDS.length > 0
                    );
                }
                return false;
            });
        });

        if (hasContent) {
            async function runFunctions() {
                await openModal_for_deviceIds(productNames);
                await storeDeviceGroups();
                await useDeviceGroupsData();
            }
            runFunctions();
        }
    } else {
        window.location.href = "/checkout";
    }

    setTimeout(function() {
        var deviceIdsEl = document.getElementById('device-ids');
        var modalCheckoutEl = document.getElementById("modal_checkout");
        if (deviceIdsEl && modalCheckoutEl) {
            modalCheckoutEl.style.maxWidth = deviceIdsEl.offsetWidth + 'px';
        }
        handleDeviceIdsChange();
    }, 1000);

    setTimeout(function() {
        if (sessionStorage.getItem("checkedItems")) {
            var proceedButton = document.getElementById("modal_checkout");
            if (proceedButton) proceedButton.disabled = true;
            handleDeviceIdsChange();
        }
        handleDeviceIdsChange();
    }, 2000);
    setTimeout(handleDeviceIdsChange, 3000);
}

// document.getElementById("checkout").addEventListener("click", function(e) {
//     var checkoutBtn = document.getElementById("checkout");
//     if (!checkoutBtn || checkoutBtn.disabled) return;

// new code added
document.addEventListener("click", function(e) {
    if (!e.target.closest('#checkout')) return;
    var checkoutBtn = document.getElementById("checkout");
    if (!checkoutBtn || checkoutBtn.disabled) return;
//end
    if (typeof window.ds2ValidateCartSubscribedBeforeCheckout === 'function') {
        if (!window.ds2ValidateCartSubscribedBeforeCheckout()) {
            e.preventDefault();
            return;
        }
    }

    fetch("/cart.js", { cache: "no-store" })
        .then((response) => response.json())
        .then((cart) => {
            // Live Streaming consent check: if cart has consent_form items and no eSignature, show popup
            var hasLiveStreaming = (window.cartItemsForConsent || []).some(function(item) {
                return item.tags && Array.isArray(item.tags) && item.tags.includes('consent_form');
            });
            var eSignature = (cart.attributes && cart.attributes.eSignature) ? String(cart.attributes.eSignature).trim() : '';
            var needsConsent = hasLiveStreaming && !eSignature;

            if (needsConsent) {
                e.preventDefault();
                if (typeof analytics !== 'undefined' && analytics.track) {
                    analytics.track('DS2_consentform_checkout_popup_shown', {
                        source: 'cart',
                        trigger: 'submit_order_request',
                        context: 'checkout_button'
                    });
                }
                if (typeof consent_form_openPopup === 'function') {
                    consent_form_openPopup();
                }
                return;
            }

            runCheckoutFlow(cart);
        })
        .catch((error) => console.error("Error:", error));
});

// When user accepts consent on cart, proceed with checkout flow
window.addEventListener('consent_form_cart_accepted', function() {
    fetch("/cart.js", { cache: "no-store" })
        .then((response) => response.json())
        .then((cart) => {
            runCheckoutFlow(cart);
        })
        .catch((error) => console.error("Error:", error));
});

document.getElementById("modal_checkout").addEventListener("click", async function() {
     if(localStorage.getItem('__ui')) {  
            localStorage.removeItem('__ui');  
      }
    // Select all checked checkboxes within the 'device-ids' element  
    var checkedCheckboxes = document.querySelectorAll('.serialId_checkbox:checked');

    // Construct the attributes object  
    var attributes = {};

    checkedCheckboxes.forEach(function(checkbox) {
        // Use the id of the parent div as the key  
        var key = checkbox.closest('.device-group').id;

        // Use the id of the checkbox as the value  
        var value = checkbox.id;
        // If key is already in attributes, append to it. Otherwise, add it.  
        if (attributes[key]) {
            attributes[key] += ',' + value; 
        } else {
            attributes[key] = value;
        }
    });

    if(localStorage.getItem('__ui'))
      localStorage.removeItem('__ui')
    // Display the attributes object in a dialog box  

    var updated_attributes = {};  
    updated_attributes = attributes;   
    // alert("attributes" + JSON.stringify(attributes));  
    // alert("updated_attributes" + JSON.stringify(updated_attributes));
    for (var key in updated_attributes) {
      updated_attributes[key] = updated_attributes[key]
        .split(',')
        .map(function(item) {
          return item.split(' | ')[0].trim();
        })
        .join(',');
    }

    // alert(JSON.stringify(updated_attributes));  
    // console.log("updated_attributes", updated_attributes);
    await updateCartValue(updated_attributes);  
  
});

function updateCartBlank(){

  
    fetch('/cart/update.js', {
            method: 'POST',
            cache: 'no-store',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              attributes: {"D-410":"","D-210":"","D-450":"","D-215":"","D-430":""}
            })
        })
        .then(response => response.json())
        .then(data => {
            // console.log('Cart updated: ', JSON.stringify(data));
        })
        .catch(error => console.error('Error:', error));
}


async function updateCartValue(updated_attributes) {
  const clean = {};

  for (const key in updated_attributes) {
    const value = String(updated_attributes[key]);
    clean[key] = DOMPurify.sanitize(value, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }).slice(0, 200);
  }
//   alert("clean:\n" + JSON.stringify(clean, null, 2));

  await fetch('/cart/update.js', {
    method: 'POST',
    cache: 'no-store',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: clean }),
  });
}

function showErrorPopup(message) {
    // Create overlay
    var overlay = document.createElement("div");
    overlay.className = "error-popup-overlay";
    overlay.innerHTML = " ";

    // Create div
    var popupDiv = document.createElement("div");
    popupDiv.className = "error-popup-popupDiv";

    // Create p
    var popupText = document.createElement("p");
    popupText.className = "error-popup-popupText";

    // Replace newline character with <br> for HTML
    message = message.replace(/\n/g, "<br>");
    popupText.innerHTML = message;
    popupDiv.appendChild(popupText);

    // Create button container
    var buttonContainer = document.createElement("div");
    buttonContainer.className = "button-container";

    // Create button
    var popupButton = document.createElement("button");
    popupButton.className = "error-popup-popupButton";
    popupButton.innerText = "OK";
    popupButton.addEventListener("click", function() {
        document.body.removeChild(popupDiv);
        document.body.removeChild(overlay);
        window.location.href = IDMS_REDIRECTION;
    });

    // Add button to button container
    buttonContainer.appendChild(popupButton);

    // Add button container to popup div
    popupDiv.appendChild(buttonContainer);

    // Append to body
    document.body.appendChild(overlay);
    document.body.appendChild(popupDiv);
}

//This function is for the Submit Order Button to be enabled on after clicking the Red Cross on the Serial ID popup
function enableCheckoutButton() {  
  document.getElementById("checkout").disabled = false;  
} 
